import { TAB_DEFAULT_BASE_NAME } from '@/features/dashboard/constants/names';
import {
  normalizeDashboardTabs,
  normalizeTabEntry,
  processMarketApps
} from '@/features/dashboard/lib/transformers';
import type { DashboardResponse, DashboardTab } from '@/features/dashboard/types';
import { generateUniqueUUID } from '@/shared/lib/format/generateUniqueUUID';

/**
 * Normalizes a raw dashboard response (single dashboard) into a DashboardTab.
 * Reused by both useDashboard and useSharedDashboard.
 */
export const normalizeDashboardEntry = (name: string, value: DashboardResponse): DashboardTab => {
  const dashboardTabs: DashboardTab = normalizeDashboardTabs(value, name, name) ?? {
    [TAB_DEFAULT_BASE_NAME]: { id: generateUniqueUUID(new Set()), content: [] }
  };

  return Object.fromEntries(
    Object.entries(dashboardTabs).map(([tabName, tabValue]) => {
      const tabEntry = normalizeTabEntry(tabName, tabValue);
      return [
        tabName,
        {
          ...tabEntry,
          content: processMarketApps(tabEntry.content)
        }
      ];
    })
  );
};
